




















import { Component, Vue } from "vue-property-decorator"
import os from "os";
let timer: any;

@Component
export default class MemoryBall extends Vue {
    used: string = "";
    total: string = "";
    percent: number = 0;
    overSize: boolean = false;
    pUse: number = 0;

    mounted() {
        this.getMem()
        timer = setInterval(() => {
            this.getMem()
        }, 2000)
    }
    beforeDestroy() {
        clearInterval(timer)
        timer = undefined
    }

    format(bytes:any) {
        return (bytes / 1024 / 1024).toFixed(2) + "MB"
    }

    getMem() {
        let mem = process.memoryUsage(),
            hasUsed = os.totalmem() - os.freemem();
        this.total = this.format(hasUsed);
        this.used = this.format(mem.rss);
        this.percent = Math.floor((hasUsed / os.totalmem()) * 100)
        this.pUse = Math.round((mem.rss / os.totalmem()) * 100)
        if ((mem.rss / 1024 / 1024) > 350) this.overSize = true
        else this.overSize = false
    }
}
